/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

import template from './test-style-page.component.html';
import {SIMPLE_PAGE_IMPORTS} from './simple-page-imports';

@Component({
  standalone: true,
  imports: SIMPLE_PAGE_IMPORTS,
  selector: 'adn-test-style-page',
  template
})
export class TestStylePageComponent {
}
